<template>
  <!-- 密码验证界面 -->
  <div class="password-container" v-if="!isAuthenticated">
    <div class="password-dialog">
      <div class="password-header">
        <h2>莲蓉园商贸管理系统</h2>
        <p>请输入密码访问</p>
      </div>
      <div class="password-input">
        <el-input
          v-model="password"
          type="password"
          placeholder="请输入密码"
          @keyup.enter="checkPassword"
          :class="{ 'error': passwordError }"
        ></el-input>
        <p class="error-message" v-if="passwordError">{{ passwordError }}</p>
      </div>
      <div class="password-actions">
        <el-button type="primary" @click="checkPassword" :loading="loading">进入系统</el-button>
      </div>
    </div>
  </div>

  <!-- 主界面 -->
  <div class="home-container" v-else>
    <!-- 顶部标题 -->
    <div class="header">
      <h1 class="title">莲蓉园商贸有限公司</h1>
      <p class="subtitle">欢迎使用销售订单管理系统</p>
      <div class="logout-btn">
        <el-button size="small" @click="logout">退出系统</el-button>
      </div>
    </div>

    <!-- 功能卡片区域 -->
    <div class="feature-cards">
      <!-- 销售开单卡片 -->
      <el-card class="feature-card" shadow="hover" @click="navigateTo('/orders/create')">
        <div class="card-content">
          <div class="card-icon" style="background: linear-gradient(135deg, #3b82f6, #2563eb);">
            <i class="el-icon-document"></i>
          </div>
          <div class="card-info">
            <h3>销售开单</h3>
            <p>创建新的销售订单</p>
          </div>
        </div>
      </el-card>

      <!-- 统计卡片 -->
      <el-card class="feature-card" shadow="hover" @click="navigateTo('/statistics')">
        <div class="card-content">
          <div class="card-icon" style="background: linear-gradient(135deg, #8b5cf6, #6d28d9);">
            <i class="el-icon-data-analysis"></i>
          </div>
          <div class="card-info">
            <h3>数据统计</h3>
            <p>查看销售统计数据</p>
          </div>
        </div>
      </el-card>

      <!-- 订单管理卡片 -->
      <el-card class="feature-card" shadow="hover" @click="navigateTo('/orders')">
        <div class="card-content">
          <div class="card-icon" style="background: linear-gradient(135deg, #10b981, #059669);">
            <i class="el-icon-tickets"></i>
          </div>
          <div class="card-info">
            <h3>订单管理</h3>
            <p>查看和管理所有订单</p>
          </div>
        </div>
      </el-card>

      <!-- 客户管理卡片 -->
      <el-card class="feature-card" shadow="hover" @click="navigateTo('/customers')">
        <div class="card-content">
          <div class="card-icon" style="background: linear-gradient(135deg, #f59e0b, #d97706);">
            <i class="el-icon-user"></i>
          </div>
          <div class="card-info">
            <h3>客户管理</h3>
            <p>管理客户信息</p>
          </div>
        </div>
      </el-card>

      <!-- 商品管理卡片 -->
      <el-card class="feature-card" shadow="hover" @click="navigateTo('/merchandises')">
        <div class="card-content">
          <div class="card-icon" style="background: linear-gradient(135deg, #ef4444, #dc2626);">
            <i class="el-icon-goods"></i>
          </div>
          <div class="card-info">
            <h3>商品管理</h3>
            <p>管理商品信息</p>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  data() {
    return {
      isAuthenticated: false,
      password: '',
      passwordError: '',
      loading: false,
      correctPassword: '18100885307'
    }
  },
  mounted() {
    const auth = localStorage.getItem('systemAuthenticated');
    if (auth === 'true') {
      this.isAuthenticated = true;
    }
  },
  methods: {
    checkPassword() {
      this.loading = true;
      this.passwordError = '';
      setTimeout(() => {
        if (this.password === this.correctPassword) {
          this.isAuthenticated = true;
          localStorage.setItem('systemAuthenticated', 'true');
        } else {
          this.passwordError = '密码错误，请重新输入';
        }
        this.loading = false;
      }, 500);
    },
    logout() {
      this.isAuthenticated = false;
      this.password = '';
      localStorage.removeItem('systemAuthenticated');
    },
    navigateTo(path) {
      this.$router.push(path)
    }
  }
}
</script>

<style scoped>
.home-container {
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
  animation: fadeIn 0.4s ease;
}
.header {
  text-align: center;
  margin-bottom: 48px;
  position: relative;
}
.title {
  font-size: 36px;
  font-weight: 700;
  background: linear-gradient(135deg, #1e293b, #3b82f6);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  margin-bottom: 8px;
}
.subtitle {
  font-size: 16px;
  color: #64748b;
}
.logout-btn {
  position: absolute;
  top: 0;
  right: 0;
}
.feature-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
  margin-bottom: 40px;
}
.feature-card {
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.2, 0.9, 0.4, 1.1);
  height: 130px;
  border-radius: 24px;
  overflow: hidden;
  border: none;
}
.feature-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 20px 30px -12px rgba(0, 0, 0, 0.15) !important;
}
.card-content {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 16px;
}
.card-icon {
  width: 60px;
  height: 60px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  transition: all 0.3s;
  box-shadow: 0 8px 16px -8px rgba(0, 0, 0, 0.2);
}
.feature-card:hover .card-icon {
  transform: scale(1.05);
}
.card-icon i {
  font-size: 28px;
  color: white;
}
.card-info h3 {
  margin: 0 0 6px 0;
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
}
.card-info p {
  margin: 0;
  color: #64748b;
  font-size: 14px;
}
.password-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  animation: fadeIn 0.4s ease;
}
.password-dialog {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  padding: 40px;
  border-radius: 32px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  width: 400px;
  max-width: 90%;
  text-align: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
}
.password-header h2 {
  color: #1e293b;
  margin-bottom: 8px;
  font-size: 26px;
}
.password-header p {
  color: #64748b;
  font-size: 14px;
}
.password-input {
  margin: 24px 0;
}
.password-input .el-input__inner {
  border-radius: 40px;
  padding: 12px 20px;
  border: 1px solid #e2e8f0;
  background: white;
  transition: all 0.2s;
}
.password-input .el-input__inner:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
}
.error-message {
  color: var(--danger-color);
  font-size: 12px;
  margin-top: 8px;
  text-align: left;
}
.password-actions .el-button {
  width: 100%;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border: none;
  border-radius: 40px;
  padding: 12px;
  font-weight: 600;
}
.password-actions .el-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px -6px rgba(102, 126, 234, 0.5);
}
@media (max-width: 768px) {
  .home-container {
    padding: 16px;
  }
  .header {
    margin-bottom: 32px;
  }
  .title {
    font-size: 24px;
  }
  .subtitle {
    font-size: 14px;
  }
  .logout-btn {
    position: static;
    margin-top: 12px;
  }
  .feature-cards {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .feature-card {
    height: auto;
  }
  .card-content {
    padding: 12px;
  }
  .card-icon {
    width: 48px;
    height: 48px;
    border-radius: 16px;
  }
  .card-icon i {
    font-size: 22px;
  }
  .card-info h3 {
    font-size: 16px;
  }
  .password-dialog {
    padding: 24px;
    width: 85%;
  }
  .password-header h2 {
    font-size: 22px;
  }
}
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>